export default __webpack_public_path__ + "static/media/folders-form-icon.9357bc76.svg";